module.exports = __webpack_public_path__ + "img/666864_B3B4AB_2F2F2C_9CA49B-256px.acf1bb5c.png";